var map = {
	"./adult/play-btn.svg": 3677,
	"./confidence/play-btn.svg": 4275,
	"./couples/play-btn.svg": 3768,
	"./nice/play-btn.svg": 5342,
	"./psycho/play-btn.svg": 8603,
	"./quirky/play-btn.svg": 1798,
	"./rude/play-btn.svg": 5158,
	"./sex/play-btn.svg": 4629,
	"./spicy-couple/play-btn.svg": 3938,
	"./spicy/play-btn.svg": 5595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;